import { Helmet } from 'react-helmet';

export default Helmet;



// WEBPACK FOOTER //
// ./src/services/reactHelmetClient.js